"use client"

import type React from "react"
import { Button } from "../button"
import { Card } from "../card"

interface AssessmentResultsProps {
  onGoToDashboard: () => void
  onRetakeQuiz: () => void
}

export const AssessmentResults: React.FC<AssessmentResultsProps> = ({ onGoToDashboard, onRetakeQuiz }) => {
  return (
    <div className="text-center py-8">
      <div className="text-6xl mb-6 font-bold text-indigo-600">✓</div>
      <h2 className="text-3xl font-bold text-slate-900 mb-4">Amazing! Quiz Complete!</h2>
      <p className="text-lg text-slate-600 mb-6 max-w-md mx-auto">
        You've shared some awesome insights about yourself!
      </p>
      <Card className="bg-indigo-50 border-indigo-200 rounded-xl p-6 mb-8 max-w-md mx-auto">
        <p className="text-indigo-900 mb-2">
          <span className="font-bold">Ready to see your career matches?</span>
        </p>
        <p className="text-indigo-700 text-sm">We've analyzed your answers and found perfect careers for you!</p>
      </Card>
      <Button
        onClick={onGoToDashboard}
        className="px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold text-lg"
      >
        View My Career Matches
      </Button>
    </div>
  )
}
